/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'hide-password': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<path pid="0" d="M17 24.7c-4.2 0-8.1-2.2-11.8-6.5-.6-.7-.6-1.8 0-2.5 3.7-4.3 7.6-6.5 11.8-6.5s8.1 2.2 11.8 6.5c.6.7.6 1.8 0 2.5-3.7 4.3-7.6 6.5-11.8 6.5zM6.4 16.8c-.1.1-.1.3 0 .5 3.3 3.9 6.9 5.9 10.6 5.9 3.7 0 7.3-2 10.6-5.9.1-.1.1-.3 0-.5-3.3-3.9-6.9-5.9-10.6-5.9-3.7-.1-7.3 1.9-10.6 5.9zM17 21.6c-2.5 0-4.6-2.1-4.6-4.6s2.1-4.6 4.6-4.6 4.6 2.1 4.6 4.6-2.1 4.6-4.6 4.6zm0-7.7c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1 3.1-1.4 3.1-3.1-1.4-3.1-3.1-3.1z"/>'
  }
})
